import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { LanguageSettings } from '../types';

const LANG_SETTINGS_COLLECTION = 'languageSettings';
const LANG_SETTINGS_DOC_ID = 'main';

class LanguageSettingsService {
  // Get language settings
  async getLanguageSettings(): Promise<LanguageSettings | null> {
    try {
      const docRef = doc(db, LANG_SETTINGS_COLLECTION, LANG_SETTINGS_DOC_ID);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() } as LanguageSettings;
      }

      return null;
    } catch (error) {
      console.error('Error fetching language settings:', error);
      throw error;
    }
  }

  // Update language settings
  async updateLanguageSettings(settings: Partial<LanguageSettings>): Promise<void> {
    try {
      const docRef = doc(db, LANG_SETTINGS_COLLECTION, LANG_SETTINGS_DOC_ID);
      const docSnap = await getDoc(docRef);

      const updateData = {
        ...settings,
        updatedAt: serverTimestamp(),
      } as Partial<LanguageSettings>;

      if (docSnap.exists()) {
        await updateDoc(docRef, updateData);
      } else {
        await setDoc(docRef, {
          languages: { tr: true, en: true, ar: true },
          ...updateData,
          createdAt: serverTimestamp(),
        });
      }
    } catch (error) {
      console.error('Error updating language settings:', error);
      throw error;
    }
  }

  // Create default settings if not exist
  async createDefaultLanguageSettings(): Promise<void> {
    try {
      await this.updateLanguageSettings({
        languages: { tr: true, en: true, ar: true },
      });
    } catch (error) {
      console.error('Error creating default language settings:', error);
      throw error;
    }
  }
}

export const languageSettingsService = new LanguageSettingsService(); 